import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionCardForm, AddAnotherCardForm, RecipientsBlockForm, TEXT_TONE_OPTIONS } from '../../model';

@Component({
  selector: 'multi-shipment-recipients-block',
  templateUrl: './recipients-block.component.html',
  styleUrls: ['./recipients-block.component.scss'],
  standalone: false,
})
export class RecipientsBlockComponent {
  @Input({ required: true }) formGroup!: FormGroup<RecipientsBlockForm>;

  get addRecipientCard(): FormGroup<ActionCardForm> {
    return this.formGroup.controls.addRecipientCard;
  }

  get addAnotherRecipientCard(): FormGroup<AddAnotherCardForm> {
    return this.formGroup.controls.addAnotherRecipientCard;
  }

  readonly textToneOptions = TEXT_TONE_OPTIONS;

  onRichTextChange(control: FormControl<string>, content: string): void {
    control.setValue(content);
    control.markAsDirty();
  }
}
